import { of, throwError } from 'rxjs';

export function storeValuesValidator(values: any[]) {
  return values.some((value) => value === null || value === undefined)
    ? throwError({ message: 'CART.CART_PAGE.ERROR.SERVER_ERROR', type: 'error' })
    : of(true);
}
